import { createFileRoute } from "@tanstack/react-router";
import { GroupPreregistration } from "@/components/pre-registration/GroupPreregistration";
import { useTranslation } from "react-i18next";
import { useBuildingAdminOrReceptionistAccess } from "@/hooks/useReceptionistAccess";
import { useBuildingWelcomeVisitAccess } from "@/hooks/useBuildingWelcomeVisitAccess";

export const Route = createFileRoute(
  "/_portal/building/visitors/preregistrations/new",
)({
  component: Preregistration,
});

function Preregistration() {
  const { t } = useTranslation();
  const { allowBuildingAdminOrReceptionistAccess } =
    useBuildingAdminOrReceptionistAccess();
  const buildingHasWelcomeVisit = useBuildingWelcomeVisitAccess();

  const breadcrumbs = [
    { label: t("SIDEBAR.BUILDING_VISITORS"), path: "/building/visitors" },
    {
      label: t("BUILDING_VISITORS.PRE_REG"),
      path: "/building/visitors/preregistrations",
    },
    {
      label: t("PREREGISTRATION.HEADER"),
      path: "/building/visitors/preregistrations/new",
    },
  ];

  if (
    !allowBuildingAdminOrReceptionistAccess ||
    !buildingHasWelcomeVisit
  ) {
    return null;
  }
  return (
    <GroupPreregistration
      noResultsText={t("PREREGISTRATION.NO_RESULTS_BUILDING")}
      showAddHost
      breadcrumbs={breadcrumbs}
      showCompany
    />
  );
}
